<template>
  <div class="restaurant">
    <div class="row my-3">
      <h2 class="">{{ $t('restMenu.restaurantMenu') }}{{this.RESTAURANT.title}}</h2>
    </div>
    <div class="row pb-4">
      <div class="col-12 col-md-2 mb-3 mb-md-0">
        <router-link :to="{name: 'RestAddProduct'}" class="btn btn-sm btn-outline-success px-3">{{ $t('restMenu.addMenuItem') }}</router-link>
      </div>
      <div class="col-12 col-md-10 d-flex justify-content-between align-items-center">
        <div class="">
          <label for="searchProduct" class="form-label visually-hidden">{{ $t('restMenu.search') }}</label>
          <input v-model="search" type="text" class="form-control form-control-sm" id="searchProduct" :placeholder="$t('restMenu.searchThreeDots')">
        </div>
        <div class="d-flex align-items-center">
          <svg width="1.3rem" height="1.3rem" fill="gray" class="me-2">
            <use xlink:href="../../assets/ico/bootstrap-icons.svg#filter-right"/>
          </svg>
          <select v-model="sortParam"  class="form-select form-select-sm" aria-label="Sort restaurant's menu">
            <option v-for="(name, value) in sorting"
                    :value="value">{{ name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-if="this.LOADING.menu" class="col-12 mb-4">
        <div class="spinner-border h4 fw-normal text-dark"
             role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else class="products">
        <div v-for="category in this.RESTAURANT.settings.category_sequence">
          <div class="row">
            <div class="col-12 py-2 bg-success bg-opacity-25">
              {{ category }}
            </div>
          </div>
          <div
              v-for="product in this.sortMenu(category)"
              class="row py-2 border-bottom products_item"
              :class="{ 'text-muted': !product.is_available }"
              @click="openMenuItem(product)">
            <div class="col-6 col-md-1">
              <div class="image-box">
                <img :src="product.src_main" class="img-fluid" v-bind:alt="product.title">
<!--                <img v-if="product.src" :src="product.src" class="img-fluid" v-bind:alt="product.title">-->
<!--                <img v-else src="../../assets/img/placeholder.jpg" class="img-fluid" v-bind:alt="product.title">-->
              </div>
            </div>
            <div class="col-6 col-md-8 d-flex flex-column justify-content-start justify-content-md-center">
              <p class="fw-bold mb-0 p-0">
                {{ product.title }}
                <span v-for="variant in Object.keys(product.modifiers)" class="small fw-normal bg-primary bg-opacity-50 px-1 me-1 rounded-1">{{ variant }}

                </span>
              </p>
              <p class="p-0">{{ product.description }}</p>
            </div>
            <div class="col-5 col-md-1 d-flex flex-row align-items-center">{{ product.price }}{{ $t('restMenu.currency') }}</div>
            <div class="col-5 col-md-1 d-flex flex-row align-items-center">{{ this.productMeasure(product.weight, product.unit_measure) }}</div>
            <div class="col-2 col-md-1 d-flex flex-row align-items-center justify-content-center">
              <button v-if="product.is_available" @click.stop
                      @click="openModalChangeIsActive(product, true)"
                      class="btn btn-sm"
                      :class="[product.loading ? 'disabled btn-outline-secondary' : 'btn-outline-success']">
                <svg width="1.5rem" height="1.5rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#check-lg"/>
                </svg>
              </button>
              <button v-else @click.stop
                       @click="openModalChangeIsActive(product, false)"
                       class="btn btn-sm"
                      :class="[product.loading ? 'disabled btn-outline-secondary' : 'btn-outline-danger']">
                <svg width="1.3rem" height="1.3rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#x-lg"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal change is active-->
    <div class="modal fade" id="modalChangeIsActive" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-scrollable">
        <div v-if="changeIsActiveDisable" class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('restMenu.disable') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="text-center">{{ $t('restMenu.areYouSureYouWantDisable') }}<br> <b>{{this.changedProduct.title}}</b></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('restMenu.no') }}</button>
            <button @click="changeProductIsActive(false)" data-bs-dismiss="modal" type="button" class="btn btn-danger">{{ $t('restMenu.yes') }}</button>
          </div>
        </div>
        <div v-else class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('restMenu.enable') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="text-center">{{ $t('restMenu.areYouSureYouWantEnable') }}<br> <b>{{this.changedProduct.title}}</b></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('restMenu.no') }}</button>
            <button @click="changeProductIsActive(true)" data-bs-dismiss="modal" type="button" class="btn btn-success">{{ $t('restMenu.yes') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import i18n from "@/i18n";
import router from "@/router";
import {Modal} from "bootstrap";
import axios from "axios";
const config = require('@/config')
export default {
  name: "RestaurantMenu",
  data() {
    return {
      search: '',
      sortParam: 'default',
      sorting: {
        default: i18n.global.t('restMenu.byDefault'),
        price123: i18n.global.t('restMenu.cheapFirst'),
        price321: i18n.global.t('restMenu.expensiveFirst'),
        // categoryABC: i18n.global.t('restMenu.categoryABC'), // временно отключили, т.к сделали группировку по категориям
      },
      changedProduct: {},
      changeIsActiveDisable: false, //для понимания отключаем или включаем продукт
    }
  },
  computed: {
    ...mapGetters([
      'COMPANY',
      'RESTAURANT',
      'RESTAURANTS',
      'RESTAURANTMENU',
      'RESTAURANTMENUSORT',
      'LOADING',
    ]),
  },
  methods: {
    sortMenu(category) {
      const productInCategory = this.RESTAURANTMENU.filter(function (prod) {
        return prod.category === category
      })
      this.$store.commit('setRestaurantMenuSort', this.sortParam)
      const sortDate = (d1,d2) => {
        const date1 = new Date(d1.date_updated);
        const date2 = new Date(d2.date_updated);
        return (date1 < date2) ? 1 : -1;
      };
      const sortByPrice123 = (d1,d2) => (d1.price > d2.price) ? 1 : -1;
      const sortByPrice321 = (d1,d2) => (d1.price < d2.price) ? 1 : -1;
      const sortByCategoryABC = (d1,d2) => (d1.category.toLowerCase() > d2.category.toLowerCase()) ? 1 : -1;
      switch(this.sortParam){
        case 'default': return this.searchMenu(productInCategory.sort(sortDate));
        case 'price123': return this.searchMenu(productInCategory.sort(sortByPrice123));
        case 'price321': return this.searchMenu(productInCategory.sort(sortByPrice321));
        case 'categoryABC': return this.searchMenu(productInCategory.sort(sortByCategoryABC));
        default: return productInCategory;
      }
    },
    searchMenu(arr) {
      let word = this.search.toLowerCase()
      return arr.filter(function (elem) {
        if (word === '') return true;
        else return elem.title.toLowerCase().indexOf(word) > -1;
      })
    },
    openMenuItem(product) {
      this.$store.commit('setRestaurantMenuItem', product)
      router.push({ name: 'RestMenuItem', params: {prodId: product.id} })
    },
    openModalChangeIsActive(product, type) {
      //type is boolean. true - product disable, false - product actived
      this.changeIsActiveDisable = type
      this.changedProduct = product
      let modalChangeIsActive = new Modal(document.querySelector('#modalChangeIsActive'));
      modalChangeIsActive.show();
    },
    setSpinner(type) {
      const productIndex = this.RESTAURANTMENU.findIndex((e) => {
        return e.id === this.changedProduct.id
      })
      const payload = {
        index: productIndex,
        type: type
      }
      this.$store.commit('addSpinnerToProduct', payload)
    },
    async changeProductIsActive(type) {
      // type is boolean. true - product is disabling, false - product is activates
      await this.$store.dispatch('checkIdToken')
      this.setSpinner(true)
      let idToken = this.$store.state.tokens.idToken;
      let restId = this.$route.params.id
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'application/json'}}
      let data = { 'is_available': type };
      data = JSON.stringify(data)
      axios.put(`${config.servUrl}admin/menu-items/${restId}/${this.changedProduct.id}`, data, axiosHeader)
          .then(response => {
            this.$store.dispatch('addNewNotice', {text: i18n.global.t('restMenu.menuItemHasBeenUpdated')})
            this.$store.dispatch('getRestaurantMenu', restId);
            this.setSpinner(false)
          })
          .catch(error => {
            this.$store.dispatch('addNewNotice', {text: error, error: true})
            this.setSpinner(false)
            console.log(error);
          })
    },
    productMeasure(weight, measure) {
      return measure === null ? `${weight} ${i18n.global.t('restMenu.weightUnit')}` : `${weight} ${measure}`
    }
  },
  created() {
    this.sortParam = this.RESTAURANTMENUSORT
  },
  // mounted() {
  //   this.$store.dispatch('getCompanyInfo'); // получаем информацию о компании
  //   // this.$store.commit('clearRestaurantMenuItem'); // очищаем существующее меню
  //   let restId = this.$route.params.id;  // получаем id текущего ресторана из роута
  //   if(!Object.values(this.RESTAURANT).length) { // проверяем пуст ли ресторан - такое бывает если обновить страницу
  //     const startRest = async () => {
  //       await this.$store.dispatch('getRestaurantItem', restId) //делаем асинхронную загрузку инфорамации о ресторане
  //     }
  //     startRest().then( () => { //когда получили информацию о ресторане
  //       this.$breadcrumbs.value[2].label = this.RESTAURANT.title //меняем заголовок страницы в breadcrumbs
  //       this.$store.dispatch('getRestaurantMenu', restId); // загружаем меню ресторна
  //     })
  //   } else {
  //     this.$breadcrumbs.value[2].label = this.RESTAURANT.title //меняем заголовок страницы в breadcrumbs
  //     this.$store.dispatch('getRestaurantMenu', restId); // загружаем меню ресторна
  //   }
  // },
  watch: {
  }
}
</script>

<style scoped>

</style>
